module.exports = __webpack_public_path__ + "static/media/manualIcon.1b55f595.png";